// assets.js
import sibiu from '../assets/tursib-card.png';
import tgmures from '../assets/tgmures-card.png';
import slobozia from '../assets/slobozia-card.png';
import pitesti from '../assets/pitesti-card.png';
import carges from '../assets/carges-card.png';

const assets = {
  sibiu,
  tgmures,
  slobozia,
  carges,
  pitesti,
};

export default assets;
